import { clauseOpLabelOptions } from './constants';

/**
 * Returns the human-readable label for a clause's operator (e.g. "is in", "ends with"),
 * with negation applied. Returns `''` when no matching option is found in `clauseOpLabelOptions`,
 * so callers should fall back with `||` (not `??`).
 *
 * Accepts a structural subset (just `op` and `negate`) so callers can build the input from
 * loosely-typed (`unknown`) data without an `as Clause` cast.
 */
export function getOperationLabel(clause: { op: string; negate?: boolean }) {
  const { op, negate } = clause;

  const matchingOption = clauseOpLabelOptions.find((d) => op === d.op && d.negate === negate);
  return matchingOption?.label || '';
}
